module.exports = __webpack_public_path__ + "img/202504_03.a0fe013f.jpg";